<ion-content [fullscreen]="true" class="ion-padding sheet">
	<ion-buttons class="close-btn">
		<ion-button (click)="close()" fill="clear">
			<ion-icon name="close"></ion-icon>
		</ion-button>
	</ion-buttons>

	<div class="content-wrapper">
		<ion-icon class="alert-icon" name="alert-circle-outline"></ion-icon>

		<h2 class="title">{{ 'splitChangeBlocked.title' | translate }}</h2>

		<p class="message">{{ 'splitChangeBlocked.message' | translate }}</p>

		<ion-button (click)="close()" class="confirm" expand="block"> {{ 'common.understood' | translate }}</ion-button>
	</div>
</ion-content>
